import routerOptions0 from "/usr/src/app/node_modules/.pnpm/nuxt@4.5.2_96f78f722f28c2ddc32c3eeb6be90bb0/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}